export class myLocalStorage {
  static NAMESPACE = 'abc123:';

  static getKey = (key: string): string => {
    return `${this.NAMESPACE}${key}`;
  };

  static removeItem = (key: string): void => {
    localStorage.removeItem(this.getKey(key));
  };

  static setItem = (key: string, value: any): void => {
    localStorage.setItem(this.getKey(key), JSON.stringify(value));
  };

  static getItem = (key: string): any => {
    //Logger.log(`key: ${key}`);
    if (!key) {
      return undefined;
    }

    const value = localStorage.getItem(this.getKey(key));
    //Logger.log(`value: ${value}`);
    return value !== undefined && value !== null && value !== 'undefined'
      ? JSON.parse(value)
      : value;
  };

  static clearNewBook = (): void => {
    //Logger.log(`clearNewBook..`);
    myLocalStorage.removeItem('newBook');
    myLocalStorage.removeItem('newBookPublisher');
    myLocalStorage.removeItem('newBookStep');
  };

  static clearNewEdition = (): void => {
    myLocalStorage.removeItem('newEdition');
    myLocalStorage.removeItem('newEditionStep');
  };

  static clearConsentAccepted = (enrollmentId: number): void => {
    myLocalStorage.removeItem(`consentVersion_enrollment_${enrollmentId}`);
  };
}
